import { InvestState, RootState } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import {
  FETCH_INVEST_DATA,
  FETCH_QUARTERLY_REPORTS,
  FETCH_ANNUAL_REPORTS,
  FETCH_SENSITIVE_REPORTS
} from "./actions.names";
import { API_URL } from "../global";
import axios from "axios";
import { SET_INVEST_DATA, SET_INVEST_DATA_ERROR } from "./mutations.names";
import Vue from "vue";
import {
  QUARTERLY_REPORT_API,
  ANNUAL_REPORT_API,
  SENSITIVE_REPORT_API
} from "./endpoints";

export const state: InvestState = {
  data: [],
  error: false
};

const namespaced: boolean = false;

const getters: GetterTree<InvestState, RootState> = {
  investData(state) {
    // if (!state) {
    //   return undefined;
    // }
    return state.data;
  }
};

const actions: ActionTree<InvestState, RootState> = {
  async [FETCH_INVEST_DATA]({ commit }, id: number): Promise<any> {
    axios
      .get(`${API_URL}/pages/?child_of=${id}&type=pages.InvestorPage&fields`)
      .then(({ data }) => {
        commit(SET_INVEST_DATA, data.items);
      })
      .catch((err: any) => {
        commit(SET_INVEST_DATA_ERROR);
      });
  },
  async [FETCH_QUARTERLY_REPORTS]({ commit }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(QUARTERLY_REPORT_API)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  async [FETCH_ANNUAL_REPORTS]({ commit }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(ANNUAL_REPORT_API)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  async [FETCH_SENSITIVE_REPORTS]({ commit }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(SENSITIVE_REPORT_API)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations: MutationTree<InvestState> = {
  [SET_INVEST_DATA](state, payload): any {
    // console.log(payload);
    Vue.set(state, "data", payload);
    // state.data = payload;
    state.error = false;
    // console.log(state);
  },
  [SET_INVEST_DATA_ERROR](state: any): any {
    state.data = [];
    state.error = true;
  }
};

export const investData: Module<InvestState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
